export function saveSurveyResponse({ answers, identifier, otherText, questionIdentifier, score, text, url, userUuid }) {
  return $.ajax({
    contentType: "application/json",
    data: JSON.stringify({
      survey_response: {
        answers: answers,
        other_text: otherText,
        question_identifier: questionIdentifier,
        score: score,
        survey_identifier: identifier,
        text: text
      },
      user_uuid: userUuid
    }),
    dataType: "json",
    method: "post",
    url: url
  });
}
